import { render } from "./receiveResult.vue?vue&type=template&id=46cb2742&scoped=true"
import script from "./receiveResult.vue?vue&type=script&lang=js"
export * from "./receiveResult.vue?vue&type=script&lang=js"

import "./receiveResult.vue?vue&type=style&index=0&id=46cb2742&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_T3ED/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cb2742"]])

export default __exports__